import React from 'react'
import Columns from './Columns';
import { Slider } from './Slider';
import { isMobile } from '../../service';

const MegaMenus = ({ item, open,onClick }) => {
    
    if(isMobile()){
        return (<div  className={`
            overflow-hidden
            transition-all duration-500 ease-in-out
            ${open ? "max-h-[2000px]" : "max-h-0"}
          `}
          >
                {(item.columns || item.categories) && <Columns item={item}  onClick={onClick}  />}
                {item.colection && item.colection?.isSlider && <Slider item={item}  onClick={onClick} />}
              
            </div>
            
        )
    }else{
        return (
            
            <div className={`
                absolute left-0 right-0 top-[calc(100%+10px)] bg-white shadow-md  z-50
            h-auto overflow-hidden 
            opacity-0 translate-y-[-10px] 
           ${open ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-2 pointer-events-none"}
          transition-all duration-300 ease-out group/mega`}>
                {(item.columns || item.categories) && <Columns item={item}  onClick={onClick} />}
                {item.colection && item.colection?.isSlider && <Slider item={item}  onClick={onClick}  />}
              
            </div>
        )
    }
  
}
export default MegaMenus;